<template>
  <footer class="footer">
    <div class="footer-grid container">
      <div class="footer-brand">
        <div class="footer-brand-head">
          <img class="footer-logo" src="../assets/image/logo.svg" alt="logo" />
        </div>
        <p class="footer-desc">专注电子口岸入网在线企业服务，为进出口企业提供一站式、全流程的专业服务解决方案。</p>
        <div class="footer-contact">
          <span>📞 {{ siteConfig.servicePhone || "400-XXX-XXXX" }}</span>
          <span>📧 {{ siteConfig.serviceEmail || "service@icka.cn" }}</span>
          <span>🕐 {{ siteConfig.workTime || "工作日 9:00-18:00" }}</span>
        </div>
      </div>

      <div class="link-column">
        <h4>制卡业务</h4>
        <ul>
          <li><a href="/business">企业新入网</a></li>
          <li><a href="/business">新增业务</a></li>
          <li><a href="/business">变更业务</a></li>
          <li><a href="/business">补办业务</a></li>
          <li><a href="/business">更新解锁</a></li>
          <li><a href="/business">安全产品</a></li>
        </ul>
      </div>

      <div class="link-column">
        <h4>进出口权</h4>
        <ul>
          <li><a href="/#import-rights">海关备案</a></li>
          <li><a href="/#import-rights">外汇名录</a></li>
          <li><a href="/business">电子口岸卡</a></li>
          <li><a href="/#import-rights">退税备案</a></li>
        </ul>
      </div>

      <div class="link-column">
        <h4>帮助支持</h4>
        <ul>
          <li><a href="/material">材料下载</a></li>
          <li><a href="/faq">常见问题</a></li>
          <li><a href="/news">政策资讯</a></li>
          <li><a href="javascript:;">联系我们</a></li>
        </ul>
      </div>
    </div>

    <div class="footer-wrap">
      <div class="footer-bottom-inner container">
        <span class="footer-bottom-left">
          <template v-if="siteConfig.copyright">{{ siteConfig.copyright }}</template>
          <template v-else>Copyright © 2026 电子口岸IC卡 · All Rights Reserved</template>
          <template v-if="siteConfig.icpNumber">
            ·
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              class="icp-link"
            >
              {{ siteConfig.icpNumber }}
            </a>
          </template>
        </span>
        <div class="footer-bottom-links">
          <a href="javascript:;" @click.prevent="openPolicy('privacy')">隐私政策</a>
          <a href="javascript:;" @click.prevent="openPolicy('terms')">服务条款</a>
        </div>
      </div>
    </div>

    <PolicyPreviewModal ref="policyModalRef" />
  </footer>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { message } from "ant-design-vue";
import PolicyPreviewModal from "./PolicyPreviewModal.vue";
import { getPolicyFile } from "@/constants/policy";

const store = useStore();
const siteConfig = computed(() => store.getters.getSiteConfig);
const policyModalRef = ref(null);

function openPolicy(type) {
  const policy = getPolicyFile(type, siteConfig.value);
  if (!policy?.url) {
    message.warning("暂未配置政策文件");
    return;
  }
  policyModalRef.value?.open({
    title: policy.title,
    url: policy.url,
  });
}
</script>

<style lang="scss" scoped>
.footer {
  background: #1a3a6b;
  color: rgba(255, 255, 255, 0.65);
  padding: 32px 0 0;
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.footer-brand-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.footer-logo {
  height: 32px;
  filter: brightness(0) invert(1);
  opacity: 0.8;
  flex-shrink: 0;
}

.footer-brand-text {
  .brand-name {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    line-height: 1.3;
  }

  .brand-url {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.45);
    margin-top: 2px;
  }
}

.footer-desc {
  font-size: 12px;
  line-height: 1.8;
  margin-top: 9px;
  color: rgba(255, 255, 255, 0.45);
}

.footer-contact {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  span {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.65);
  }
}

.link-column {
  h4 {
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 9px;
    padding-bottom: 5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 0;
    margin: 0;

    li a {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.45);
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: #f07800;
      }
    }
  }
}

.footer-wrap {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 11px 0;
  font-size: 12px;
}

.footer-bottom-left {
  color: rgba(255, 255, 255, 0.28);

  .icp-link {
    color: rgba(255, 255, 255, 0.28);
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

.footer-bottom-links {
  display: flex;
  align-items: center;
  flex-shrink: 0;

  a {
    color: rgba(255, 255, 255, 0.28);
    text-decoration: none;
    font-size: 12px;
    margin-left: 11px;
    transition: color 0.2s;
    cursor: pointer;

    &:hover {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

@media (max-width: 768px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 24px 16px;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }

  .footer-bottom-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 0 16px;
  }

  .footer-bottom-links a:first-child {
    margin-left: 0;
  }
}
</style>
